import { render, staticRenderFns } from "./trainList.vue?vue&type=template&id=886c1f94&scoped=true&"
import script from "./trainList.vue?vue&type=script&lang=js&"
export * from "./trainList.vue?vue&type=script&lang=js&"
import style0 from "./trainList.vue?vue&type=style&index=0&id=886c1f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886c1f94",
  null
  
)

export default component.exports